import React, { useState, useEffect } from 'react';
import { SearchInput } from 'common/SearchInput';
import { filterByValue } from 'utils/helpers';
import { AlertListItem } from './AlertListItem';

export const AlertList = ({ alerts, selectedAlert, handleAlertSelect, setActiveView }) => {
    const [searchValue, setSearchValue] = useState('');
    const [visibleAlerts, setVisibleAlerts] = useState([]);

    useEffect(() => {
        setVisibleAlerts(alerts);
    }, [alerts]);

    useEffect(() => {
        const newList = filterByValue(alerts, 'name', searchValue);
        setVisibleAlerts(newList);
    }, [searchValue]);

    return (
        <div className="mobile-reader-list mobile-reader-alert-list">
            <div className='flex justify-content-between align-center'>
                <div className="mobile-reader-list__header mobile-reader-alert-list__header">
                    Alerts ({visibleAlerts.length} {visibleAlerts.length === 1 ? 'Result' : 'Results'})
                </div>
                <i onClick={() => setActiveView('manageAlerts')} className='fa fa-plus m-3' style={{ cursor: 'pointer' }} />
            </div>

            <div className="mobile-reader-alert-list__searchbar">
                <SearchInput
                    placeholder="Search by alert name"
                    value={searchValue}
                    classNames={['reader-column__input reader-alert-list__input']}
                    iconClassNames={['reader-alert-list__searchbar-icon']}
                    closeClassNames={['reader-alert-list__searchbar-icon']}
                    onChange={setSearchValue}
                    onClear={() => setSearchValue('')}
                />
            </div>

            <div className="mobile-reader-list__body mobile-reader-alert-list__body">
                {visibleAlerts.length < 1 ? (
                    <div className="mobile-reader-alert">No alerts found</div>
                ) : (
                    visibleAlerts.map((alert) => (
                        <AlertListItem
                            alert={alert}
                            key={alert.id}
                            isSelected={alert.id === selectedAlert.id}
                            handleAlertSelect={handleAlertSelect}
                        />
                    ))
                )}
            </div>
        </div>
    );
};
